var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVueltaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99462 15L15.8808 3.64621C16.0181 3.4721 15.8942 3.21429 15.6698 3.21429H13.0817C12.9176 3.21429 12.7602 3.2913 12.6598 3.41853L4.1118 14.3404C3.96376 14.529 3.8833 14.7619 3.8833 15.0017C3.8833 15.2415 3.96376 15.4743 4.1118 15.6629L12.6598 26.5815C12.7602 26.7121 12.9176 26.7857 13.0817 26.7857H15.6698C15.8942 26.7857 16.0181 26.5279 15.8808 26.3538L6.99462 15ZM17.1732 15L26.0593 3.64621C26.1966 3.4721 26.0727 3.21429 25.8484 3.21429H23.2602C23.0962 3.21429 22.9388 3.2913 22.8384 3.41853L14.2904 14.3404C14.1423 14.529 14.0619 14.7619 14.0619 15.0017C14.0619 15.2415 14.1423 15.4743 14.2904 15.6629L22.8384 26.5815C22.9388 26.7121 23.0962 26.7857 23.2602 26.7857H25.8484C26.0727 26.7857 26.1966 26.5279 26.0593 26.3538L17.1732 15Z",
    fill: "#0885C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVueltaIcon);
export default __webpack_public_path__ + "static/media/vuelta-icon.5c78a27267f84f01eb80e1fa06d47699.svg";
export { ForwardRef as ReactComponent };